import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'
import {HIERARCHY_LEVEL_CLASSES} from "../../../../components/counterCPT/constants"
import {HierarchyLevels} from "constants"
import IndeterminateCustomCheckboxWithMenu from './IndeterminateCustomCheckboxWithMenu'
import {getInstance as assignmentsTooltip} from '../../../../SimpleSingletonTooltip'

export default class EntityListItem extends TemplateView {
    constructor({
        hierarchyLevel = '',
        showProjectsCount = false,
        showTasksCount = false,
        clickable = false,
        isArchived = false,
        onAssignmentChanged = (assigned) => {},
        onClick = () => {},
        revokeMenu = null,
        revokeMenuTextsMaps = {},
    }) {
        super()

        this.props = {
            hierarchyLevel,
            showProjectsCount,
            showTasksCount,
            clickable,
            revokeMenu,
            revokeMenuTextsMaps,
        }

        this.callbacks = {
            onAssignmentChanged,
            onClick
        }

        this.state = {
            name: '',
            assigned: false,
            disabled: false,
            projectsCount: null,
            tasksCount: null,
            isArchived: false,
            disabledTooltipText: "",
            canManageSubtitleText: "",
            showCanManage: false,
        }

        this.onStatePropertyChanged('name', name => this.$name.text(name))

        this.onAnyStatePropertyChanged(['disabled', 'disabledTooltipText'], ({disabled, disabledTooltipText}) => {
            this.$el.toggleClass('disabled', disabled)
            this.checkbox.setState({
                disabled,
            })

            this.unsubscribeTooltip && this.unsubscribeTooltip()
            if (disabled && disabledTooltipText) {
                this.unsubscribeTooltip = assignmentsTooltip().subscribeToMouseEvents(this.checkbox.getEl(), () => {
                    assignmentsTooltip().setState({
                        text: disabledTooltipText,
                        extraClass: 'hierarchyAssignmentsTooltip',
                    })
                })
            }
        })

        this.onAnyStatePropertyChanged(['projectsCount', 'tasksCount', 'assigned', 'isArchived', 'showCanManage', 'canManageSubtitleText'], ({projectsCount, tasksCount, assigned, isArchived, showCanManage, canManageSubtitleText}) => {
            this.$projectsCountContainer.toggle(assigned || projectsCount > 0)
            this.$tasksCountContainer.toggle(assigned || tasksCount > 0)

            if (!assigned) {
                this.$projectsCount.text(projectsCount)
                this.$tasksCount.text(tasksCount)
            } else {
                const message = messageResource.getMessage('common.all')
                this.$projectsCount.text(message)
                this.$tasksCount.text(message)
            }

            this.checkbox.setState({
                checked: assigned,
                indeterminate: !assigned && projectsCount + tasksCount > 0
            });

            if(isArchived) {
                this.$archivedSubTitle.text(this.props.hierarchyLevel === HierarchyLevels.TASK ?
                                            messageResource .getMessage('panel.common.completed') :
                                            messageResource.getMessage('panel.common.archived'))
            }

            this.find('.tasksCounterContainer').toggleClass('tasksCounterContainerCenter', this.props.hierarchyLevel === HierarchyLevels.PROJECT)

            this.$archivedSubTitle.toggle(isArchived)

            this.$canManageSubTitle.toggle(showCanManage)
            this.$canManageSubTitle.text(canManageSubtitleText)
            this.$nameContainer.toggleClass('canManage', showCanManage)

            this.$el.toggleClass('assigned', assigned)
        });
    }

    templateHtml() {
        return "<div class='entityListItem <%=hierarchyLevelClass%>'>" +
               "  <div class='checkboxPlaceholder'></div>" +
               "    <div class='nameCounterContainer'>" +
               "        <div class='nameContainer'>" +
               "            <div class='fixedNameContent'>" +
               "                <div class='name'></div>" +
               "                <div class='archivedSubTitle'></div>" +
               "            </div>" +
               "            <div class='canManageSubTitle'></div>" +
               "        </div>" +
               "        <div class='counters'> " +
               "        <%if (showProjectsCount) {%>" +
               "        <div class='projectsCounterContainer'>" +
               "            <div class='counter projects <%=projectsCounterClass%>'></div>" +
               "        </div>" +
               "        <%}%>" +
               "        <%if (showTasksCount) {%>" +
               "        <div class='tasksCounterContainer'>" +
               "            <div class='counter tasks <%=tasksCounterClass%>'></div>" +
               "        </div>" +
               "        <%}%>" +
               "        </div>" +
               "  </div>" +
               "</div>"
    }

    templateModel() {
        return {
            showProjectsCount: this.props.showProjectsCount,
            showTasksCount: this.props.showTasksCount,
            hierarchyLevelClass: HIERARCHY_LEVEL_CLASSES[this.props.hierarchyLevel],
            projectsCounterClass: HIERARCHY_LEVEL_CLASSES[HierarchyLevels.PROJECT],
            tasksCounterClass: HIERARCHY_LEVEL_CLASSES[HierarchyLevels.TASK],
        }
    }

    afterRender() {
        if (this.props.clickable) {
            this.$el.click(() => this.callbacks.onClick())
        }

        this.$checkboxPlaceholder = this.find('.checkboxPlaceholder')
        this.checkbox = new IndeterminateCustomCheckboxWithMenu({
            menu: this.props.revokeMenu,
            menuTextsMaps: this.props.revokeMenuTextsMaps,
            hierarchyLevel: this.props.hierarchyLevel,
            onClick: (checked) => this.callbacks.onAssignmentChanged(checked),
        }).init(this.$checkboxPlaceholder)

        this.$name = this.find('.name')

        if (!this.props.showProjectsCount && !this.props.showTasksCount) this.find('.counters').hide()
        this.$projectsCount = this.find('.counter.projects')
        this.$tasksCount = this.find('.counter.tasks')

        this.$projectsCountContainer = this.find('.projectsCounterContainer')
        this.$tasksCountContainer = this.find('.tasksCounterContainer')

        this.$archivedSubTitle = this.find('.archivedSubTitle')
        this.$canManageSubTitle = this.find('.canManageSubTitle')
        this.$nameContainer = this.find('.nameContainer')
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/EntityListItem.js